import React, { FC, memo, useCallback } from 'react';
import classNames from 'classnames';

import Radio from '@zvuk-b2b/react-uikit/ui/Radio';

import { CustomListItemProps } from '../types';

import styles from './index.module.scss';

const CustomListItem: FC<CustomListItemProps> = ({
  id,
  elementId,
  contentId,
  content,
  footer,
  isSelected,
  small = false,
  switcherHidden = false,
  onChange,
}) => {
  const handleChange = useCallback(() => {
    onChange(id);
  }, [onChange]);

  return (
    <div
      role="none"
      data-testid={`custom_list_item_container_${elementId}`}
      className={styles.container}
      onClick={handleChange}>
      <div
        id={contentId}
        className={classNames(styles.listItem, {
          [styles.listItemSelected]: isSelected,
          [styles.listItemSmall]: small,
        })}>
        {content}
        {!switcherHidden && (
          <Radio
            className={classNames(styles.listItemSwitcher, {
              [styles.listItemSwitcherSmall]: small,
            })}
            isChecked={isSelected}
            onChange={handleChange}
            elementId={`custom_list_item_${id}`}
          />
        )}
      </div>
      {isSelected && footer}
    </div>
  );
};

export default memo(CustomListItem);
